<template>
  <vx-card>
    <vs-popup
      fullscreen
      :title="'Edit Unit - ' + selectedUnit.name"
      :active.sync="popupActive"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-half">
          <vs-input
            v-validate="'required|min:5'"
            data-vv-validate-on="blur"
            name="name"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Name"
            v-model="selectedUnit.name"
            class="w-full"
          />
        </div>
      </div>
      <br />

      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-half">
          <label>Fuel Tank 1 Status</label>
          <vs-switch
            v-model="unitMetadataRefined.f1Status"
            @click="check(1)"
            :key="refreshKey"
            disabled
          >
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
          <vs-input
            v-if="unitMetadataRefined.f1Status == true"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="fuel"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Fuel 1 Capacity"
            v-model="unitMetadataRefined.fuel"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          <label>Fuel Tank 2 Status</label>
          <vs-switch
            v-model="unitMetadataRefined.f2Status"
            @click="check(2)"
            :key="refreshKey"
            disabled
          >
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
          <vs-input
            v-if="unitMetadataRefined.f2Status == true"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="fuel"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Fuel 2 Capacity"
            v-model="unitMetadataRefined.fuel2"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          <label>Input 1 Status</label>
          <vs-switch
            v-model="unitMetadataRefined.i1Status"
            @click="check(3)"
            :key="refreshKey"
            disabled
          >
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
        </div>
        <div
          class="vx-col md:w-1/6 w-half"
          v-if="unitMetadataRefined.i1Status == true"
        >
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="i1Name"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Input 1 Name"
            v-model="unitMetadataRefined.i1_name"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          <label>Temperature Status</label>
          <vs-switch
            v-model="unitMetadataRefined.tempStatus"
            @click="check(4)"
            :key="refreshKey"
            disabled
          >
            <span slot="on">ON</span>
            <span slot="off">OFF</span>
          </vs-switch>
          <vs-input
            v-if="unitMetadataRefined.tempStatus == true"
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="fuel"
            icon-no-border
            icon="icon icon-user"
            icon-pack="feather"
            label-placeholder="Preferred Temp Line in Chart"
            v-model="unitMetadataRefined.tempPreferred"
            class="w-full"
          />
        </div>
        <div class="vx-col md:w-1/6 w-half">
          <vs-input
            v-validate="'required'"
            data-vv-validate-on="blur"
            name="fuelPrice"
            icon-no-border
            icon-pack="feather"
            label-placeholder="Fuel Price (RM)"
            v-model="unitMetadataRefined.fuelPrice"
            class="w-full"
          />
        </div>
      </div>

      <br />

      <div class="vx-row">
        <div class="vx-col md:w-1/6 w-half">
          Icon Type
          <v-select
            :options="iconList"
            placeholder="Type"
            v-model="unitMetadataRefined.iconType"
            :clearable="false"
            label="label"
            value="value"
          >
            <template slot="option" slot-scope="option">
              <div class="row-iconBox">
                <span>{{ option.label }}</span>
                <img
                  :src="
                    require(
                      `../../experimental/map-view/icons/${option.label}.png`,
                    )
                  "
                  class="h-full border-grey-light border-solid border-1 rounded"
                  style="object-fit: contain; aspect-ratio: 1"
                  width="50"
                  height="50"
                />
              </div>
            </template>
            <template #selected-option="{ label, value }">
              <div class="row-iconBox">
                <span>{{ value }}</span>
                <img
                  :src="
                    require(`../../experimental/map-view/icons/${label}.png`)
                  "
                  class="h-full border-grey-light border-solid border-1 rounded"
                  style="object-fit: contain; aspect-ratio: 1"
                  width="50"
                  height="50"
                />
              </div>
            </template>
          </v-select>
        </div>
      </div>

      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-half">
          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-feather"
            size="small"
            @click="updateUnit"
            >Update</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-progress
      indeterminate
      color="primary"
      v-if="isLoading == true"
    ></vs-progress>

    <ejs-grid
      :key="refreshKey"
      :dataSource="unitData2"
      :allowTextWrap="true"
      height="60vh"
      gridLines="Both"
      :filterSettings="filterOptions"
      :allowPaging="true"
      :allowExcelExport="true"
      :allowPdfExport="true"
      :toolbarClick="toolbarClick"
      :searchSettings="searchOptions"
      :toolbar="toolbarOptions"
      ref="adminUnitsGrid"
      id="adminUnitsGrid"
      :pageSettings="pageSettings"
      :showColumnChooser="true"
      :allowSorting="true"
      :allowMultiSorting="true"
      :allowFiltering="true"
    >
      <e-columns>
        <e-column
          field="name"
          headerText="Asset Name"
          textAlign="Left"
        ></e-column>
        <e-column textAlign="Left" :template="cTemplate" width="80"></e-column>
      </e-columns>
    </ejs-grid>
  </vx-card>
</template>

<script>
import { Loader } from '@googlemaps/js-api-loader';
import {
  GridPlugin,
  Sort,
  Group,
  Filter,
  Toolbar,
  Resize,
  Search,
  ExcelExport,
  ColumnChooser,
  PdfExport,
  Page,
  CommandColumn,
} from '@syncfusion/ej2-vue-grids';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import columntempVue from './editButtonTemplate1.vue';
import vSelect from 'vue-select';

export default {
  components: {
    GridPlugin,
    vSelect,
    MultiSelectPlugin,
    columntempVue,
  },
  provide: {
    grid: [
      Group,
      Sort,
      Filter,
      Toolbar,
      Search,
      Resize,
      ExcelExport,
      ColumnChooser,
      PdfExport,
      Page,
      CommandColumn,
    ],
  },
  data() {
    return {
      groups: [],
      unitSelection: JSON.parse(localStorage.getItem('unitSelection')),
      allUnits: JSON.parse(localStorage.getItem('allUnits')),
      mapPOIData: JSON.parse(localStorage.getItem('mapPOIData')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      alarmData: [],
      unitData2: [],
      refreshKey: 0,
      filteredGroup: {},
      isLoading: false,
      toolbarOptions: ['Search', 'ExcelExport', 'PdfExport', 'ColumnChooser'],
      unitData: [],
      userData: [],
      groupData: [],
      poiData: [],
      fields1: { text: 'name', value: 'id' },
      fields2: { text: 'name', value: 'id' },
      fields3: { text: 'username', value: 'id' },
      fields4: { text: 'name', value: 'id' },
      fields5: { groupBy: 'assetGroup', text: 'assetName', value: 'assetId' },
      searchOptions: {
        fields: ['name', 'unitId', 'model', 'cellular'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions2: {
        fields: [
          'name',
          'username',
          'password',
          'company',
          'phone',
          'email',
          'createdBy',
        ],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions3: {
        fields: ['name'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      searchOptions4: {
        fields: ['type', 'reference'],
        operator: 'contains',
        key: '',
        ignoreCase: true,
      },
      filterOptions: { type: 'Menu' },
      pageSettings: { pageSizes: [10, 50, 100, 300, 'All'], pageSize: 10 },
      selectedUnit: {},
      unitMetadataRefined: {
        remarks: '-',
        tempStatus: false,
        tempPreferred: 0,
        temp: -1,
        i1Status: false,
        i1Status: false,
        i1: -1,
        i1_name: '',
        i2Status: false,
        i2: -1,
        i2_name: '',
        i3Status: false,
        i3: -1,
        i3_name: '',
        o1Status: false,
        o1: -1,
        o1_name: '',
        o2Status: false,
        o2: -1,
        o2_name: '',
        f1Status: false,
        fuel: -1,
        f2Status: false,
        fuel2: -1,
        totalWorkHours: 0,
        enableWorkHours: 0,
        enableWorkHoursStatus: false,
        installDate: new Date(),
        iconType: { value: 'truck-1', label: 'truck-1' },
      },
      iconList: [
        {
          value: 'animal-1',
          label: 'animal-1',
        },
        {
          value: 'boat-1',
          label: 'boat-1',
        },
        {
          value: 'car-1',
          label: 'car-1',
        },
        {
          value: 'machine-1',
          label: 'machine-1',
        },
        {
          value: 'truck-1',
          label: 'truck-1',
        },
        {
          value: 'truck-2',
          label: 'truck-2',
        },
        {
          value: 'truck-3',
          label: 'truck-3',
        },
        {
          value: 'item-1',
          label: 'item-1',
        },
        {
          value: 'watch-1',
          label: 'watch-1',
        },
        {
          value: 'staff-1',
          label: 'staff-1',
        },
      ],
      popupActive: false,
      selectedUser: {},
      loader: null,
      map: null,
      selectedPOI: {
        push_notification: 'false',
        id: null,

        draw: null,
        drawingManager: null,
        coords: [[]],
        alternateCoords: [],
        centerLat: '',
        centerLng: '',
        name: '',
        type: '',
        alert: '',
      },
      userMetadataRefined: {},
      selectedGroup: {},
      popupActive2: false,
      cTemplate() {
        return { template: columntempVue };
      },
    };
  },
  watch: {},
  methods: {
    toolbarClick(args) {
      if (args.item.id === 'adminUnitsGrid_excelexport') {
        //   this.$refs.adminUnitsGrid.getColumns()[5].visible = false;
        var exportProperties = {
          fileName: 'Units - Listing.xlsx',
          enableFilter: true,
        };
        this.$refs.adminUnitsGrid.excelExport(exportProperties);
      }
      if (args.item.id === 'adminUnitsGrid_pdfexport') {
        //        this.$refs.adminUnitsGrid.getColumns()[5].visible = false;
        var exportProperties = {
          pageOrientation: 'Potrait',
          fileName: 'Units - Listing.pdf',
        };
        this.$refs.adminUnitsGrid.pdfExport(exportProperties);
      }
    },
    check(val) {
      const self = this;
      if (val == 1) {
        self.unitMetadataRefined.f1Status = !self.unitMetadataRefined.f1Status;
        return (self.refreshKey += 1);
      }
      if (val == 2) {
        self.unitMetadataRefined.f2Status = !self.unitMetadataRefined.f2Status;
        return (self.refreshKey += 1);
      }
      if (val == 3) {
        self.unitMetadataRefined.i1Status = !self.unitMetadataRefined.i1Status;
        return (self.refreshKey += 1);
      }
      if (val == 4) {
        self.unitMetadataRefined.tempStatus =
          !self.unitMetadataRefined.tempStatus;
        return (self.refreshKey += 1);
      }
      if (val == 5) {
        self.unitMetadataRefined.enableWorkHoursStatus =
          !self.unitMetadataRefined.enableWorkHoursStatus;
        return (self.refreshKey += 1);
      }
      if (val == 6) {
        self.unitMetadataRefined.i2Status = !self.unitMetadataRefined.i2Status;
        return (self.refreshKey += 1);
      }
      if (val == 7) {
        self.unitMetadataRefined.o1Status = !self.unitMetadataRefined.o1Status;
        return (self.refreshKey += 1);
      }
      if (val == 8) {
        self.unitMetadataRefined.i3Status = !self.unitMetadataRefined.i3Status;
        return (self.refreshKey += 1);
      }
      if (val == 9) {
        self.unitMetadataRefined.o2Status = !self.unitMetadataRefined.o2Status;
        return (self.refreshKey += 1);
      }
    },
    updateUnit() {
      const self = this;
      /* if(self.unitMetadataRefined.tempStatus==true){
        self.unitMetadataRefined.temp=1
        }
        if(self.unitMetadataRefined.tempStatus==false){
          self.unitMetadataRefined.temp=-1;
        } */
      if (
        self.unitMetadataRefined.humidityStatus == false ||
        !self.unitMetadataRefined.humidityStatus
      ) {
        self.unitMetadataRefined.humidity = -1;
      }
      if (self.unitMetadataRefined.f1Status == false) {
        self.unitMetadataRefined.fuel = -1;
      }
      if (self.unitMetadataRefined.f2Status == false) {
        self.unitMetadataRefined.fuel2 = -1;
      }
      if (self.unitMetadataRefined.i1Status == true) {
        self.unitMetadataRefined.i1 = 1;
      }
      if (self.unitMetadataRefined.i1Status == false) {
        self.unitMetadataRefined.i1 = -1;
      }
      if (self.unitMetadataRefined.i2Status == true) {
        self.unitMetadataRefined.i2 = 1;
      }
      if (self.unitMetadataRefined.i2Status == false) {
        self.unitMetadataRefined.i2 = -1;
      }
      if (self.unitMetadataRefined.i3Status == true) {
        self.unitMetadataRefined.i3 = 1;
      }
      if (self.unitMetadataRefined.i3Status == false) {
        self.unitMetadataRefined.i3 = -1;
      }
      if (self.unitMetadataRefined.o1Status == true) {
        self.unitMetadataRefined.o1 = 1;
      }
      if (self.unitMetadataRefined.o1Status == false) {
        self.unitMetadataRefined.o1 = -1;
      }
      if (self.unitMetadataRefined.o2Status == true) {
        self.unitMetadataRefined.o2 = 1;
      }
      if (self.unitMetadataRefined.o2Status == false) {
        self.unitMetadataRefined.o2 = -1;
      }
      if (self.unitMetadataRefined.enableWorkHoursStatus == false) {
        self.unitMetadataRefined.enableWorkHours = -1;
      }
      if (self.unitMetadataRefined.enableWorkHoursStatus == true) {
        self.unitMetadataRefined.enableWorkHours = 1;
      }
      self.unitMetadataRefined.iconType =
        self.unitMetadataRefined.iconType.value;
      self.$http
        .patch('admin/units', {
          main: self.selectedUnit,
          meta: self.unitMetadataRefined,
          id: self.selectedUnit.id,
          oldId: self.selectedUnit.oldId,
          newId: self.selectedUnit.unitId,
        })
        .then(function (response) {
          self.popupActive = false;
          self.getData();
          self.unitMetadataRefined = {};
          self.selectedUnit = {};
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Updated asset details.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not update asset.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not update asset.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    editUnit(selectedUnit) {
      const self = this;
      self.selectedUnit = selectedUnit;
      self.$http
        .patch('admin/units/edit', {
          id: self.selectedUnit.id,
        })
        .then(function (response) {
          self.selectedUnit.groups = response.data.groups;
          self.selectedUnit.users = response.data.users;
          self.selectedUnit.oldGroups = response.data.groups;
          self.selectedUnit.oldUsers = response.data.users;
          self.selectedUnit.oldId = selectedUnit.unitId;
          self.unitMetadataRefined = JSON.parse(self.selectedUnit.meta);
          self.unitMetadataRefined.tempStatus = false;
          if (
            self.unitMetadataRefined.temp == 1 ||
            self.unitMetadataRefined.temp == 2 ||
            self.unitMetadataRefined.temp == 3 ||
            self.unitMetadataRefined.temp == 4
          ) {
            self.unitMetadataRefined.tempStatus = true;
          }
          if (self.unitMetadataRefined.fuel != -1) {
            self.unitMetadataRefined.f1Status = true;
          }

          if (self.unitMetadataRefined.fuel2 != -1) {
            self.unitMetadataRefined.f2Status = true;
          }
          if (self.unitMetadataRefined.i1 != 1) {
            self.unitMetadataRefined.i1Status = false;
          }
          if (self.unitMetadataRefined.i1 == 1) {
            self.unitMetadataRefined.i1Status = true;
          }
          if (self.unitMetadataRefined.i2 != 1) {
            self.unitMetadataRefined.i2Status = false;
          }
          if (self.unitMetadataRefined.i2 == 1) {
            self.unitMetadataRefined.i2Status = true;
          }
          if (self.unitMetadataRefined.i3 != 1) {
            self.unitMetadataRefined.i3Status = false;
          }
          if (self.unitMetadataRefined.i3 == 1) {
            self.unitMetadataRefined.i3Status = true;
          }
          if (self.unitMetadataRefined.o1 != 1) {
            self.unitMetadataRefined.o1Status = false;
          }
          if (self.unitMetadataRefined.o1 == 1) {
            self.unitMetadataRefined.o1Status = true;
          }
          if (self.unitMetadataRefined.o2 != 1) {
            self.unitMetadataRefined.o2Status = false;
          }
          if (self.unitMetadataRefined.o2 == 1) {
            self.unitMetadataRefined.o2Status = true;
          }
          if (self.unitMetadataRefined.enableWorkHours != 1) {
            self.unitMetadataRefined.enableWorkHoursStatus = false;
          }
          if (self.unitMetadataRefined.enableWorkHours == 1) {
            self.unitMetadataRefined.enableWorkHoursStatus = true;
          }
          self.unitMetadataRefined.iconType = {
            value: self.unitMetadataRefined.iconType,
            label: self.unitMetadataRefined.iconType,
          };
          //   console.log(self.unitMetadataRefined)
          self.popupActive = true;
        })
        .catch(function (error) {});
    },
    deletePOI() {
      const self = this;
      if (self.selectedPOI.id) {
        return self.$vs.notify({
          title: 'Error',
          text: 'Could not delete POI because of existing alerts subscription. Delete the alert before deleting the POI.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
      }
      self.$http
        .delete(`admin/pois/${self.selectedPOI.poiId}`, {})
        .then(function (response) {
          self.popupActive8 = false;
          self.getData();
          self.selectedPOI = {
            loader: null,
            map: null,
            draw: null,
            drawingManager: null,
            coords: [[]],
            alternateCoords: [],
            centerLat: '',
            centerLng: '',
            name: '',
            type: '',
            alert: '',
          };
          if (response.status == 200 && response.data.success) {
            return self.$vs.notify({
              title: 'Success',
              text: 'Deleted POI records.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success',
            });
          } else if (response.data.error) {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          } else {
            return self.$vs.notify({
              title: 'Error',
              text: 'Could not delete POI.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
          }
        })
        .catch(function (error) {
          return self.$vs.notify({
            title: 'Error',
            text: 'Could not delete POI.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning',
          });
        });
    },
    getData() {
      const self = this;
      self.$http
        .post('settings/unit', {
          assets: self.allUnits,
        })
        .then(function (response) {
          if (response.status == 200 && response.data.success) {
            self.unitData = response.data.unitData;
            self.unitData2 = response.data.unitData;
          } else if (response.data.error) {
          } else {
          }
        })
        .catch(function (error) {});
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
<style>
.row-iconBox {
  display: flex;
  justify-content: space-between;
}

.e-grid .e-excelexport {
  color: green;
  font-weight: bold;
}

.e-grid .e-pdfexport {
  color: red;
  font-weight: bold;
}
#map {
  height: 80vh;
}

#map2 {
  height: 80vh;
}

@import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
@import '../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css';
</style>
